module.exports = __webpack_public_path__ + "de77a722/img/send-icon.3cfb6275.svg";